"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PatientChatsProvider = void 0;
const ChatsProvider_1 = require("./ChatsProvider");
const PatientChatsContext_1 = require("./PatientChatsContext");
exports.PatientChatsProvider = (0, ChatsProvider_1.createChatProvider)(PatientChatsContext_1.PatientChatsContext, {
    getChatManager: selectedOrgUser => selectedOrgUser === null || selectedOrgUser === void 0 ? void 0 : selectedOrgUser.chatManager.getPatientChatManager(),
});
